var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPatientFamilyActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 59,
    viewBox: "0 0 56 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5361 39.5745C8.50138 41.891 -2.07741 46.6213 4.36579 52.5407C7.51324 55.432 11.0187 57.5 15.4259 57.5H40.5742C44.9815 57.5 48.487 55.432 51.6343 52.5407C58.0775 46.6213 47.4988 41.891 43.464 39.5745C34.0027 34.1418 21.9975 34.1418 12.5361 39.5745Z",
    stroke: "#3059A5",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3334 14.5C41.3334 21.6797 35.5131 27.5 28.3334 27.5C21.1537 27.5 15.3334 21.6797 15.3334 14.5C15.3334 7.3203 21.1537 1.5 28.3334 1.5C35.5131 1.5 41.3334 7.3203 41.3334 14.5Z",
    stroke: "#3059A5",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatientFamilyActive);
export default __webpack_public_path__ + "static/media/patientFamily-active.74101291ac5cf4069dd25205e1f98609.svg";
export { ForwardRef as ReactComponent };